// eslint-disable-next-line no-unused-vars
import React, { useImperativeHandle, useMemo, useState } from 'react'
import Grid, {
  FlexCell,
  defaultFlexCellRenderer,
  // freeEditEngine,
} from '@integec/grid-tools'
import { strCol } from '@integec/grid-tools/lib/cols'
import flexGridRenderer from '@integec/grid-tools/lib/flexRenderer'
import R from 'ramda'
import moment from 'moment'
// import { saveDailyPerfData } from 'api/pgads'
// import { connect } from 'react-redux'
import * as ScreenPermissions from 'core/EventActions'
import {
  BasicColHeader,
  SortIndicator,
} from '@integec/grid-tools/lib/Components'
import { Dropdown, Menu } from 'antd'
import { connect } from 'react-redux'
import {
  getClientInfo,
  getEnvConfig,
  getPermitActions,
  hasAccesPermits,
  isAdminType,
} from 'core'
import { DOM_CLIENT } from 'client'

import HourlyGenerationDetailsDOM from 'common/generation/HourlyGenerationDetailsDOM'
import numeral from 'numeral'

export const ColHeader = BasicColHeader.extend`
  flex: 0 0 ${props => props.width}px;
  width: ${props => props.width}px;
  max-width: ${props => props.width}px;
`

const defaultColHeaderRenderer = ({ header, sortOrder, width, ...rest }) => (
  <ColHeader
    width={width}
    {...rest}
    sortable={header.sortable}
    isHeader={false}
    style={{
      height: '0px',
      backgroundColor: '#eee',
      color: '#333',
      fontSize: '0.85em',
      fontWeight: 'normal',
      display: 'none',
    }}
    height={0}
  >
    {header.display}
    {sortOrder === 'asc' ? (
      <SortIndicator>&#x25b2;</SortIndicator>
    ) : sortOrder === 'desc' ? (
      <SortIndicator>&#x25bc;</SortIndicator>
    ) : null}
  </ColHeader>
)

const RestReadCell = ({
  rest,
  data,
  rowIndex,
  header,
  width,
  height,
  ...props
}) => (
  <FlexCell
    {...props}
    {...rest}
    style={{
      position: 'relative',
      // color="red",
      backgroundColor: rest.isSelected ? '#666' : '#eeeeee',
      //  backgroundColor: rest.isSelected ? '#666' : 'rgb(178,178,243)',
      fontSize: '0.85em',
      fontWeight: 'normal',
      // color: rest.isSelected ? 'black' : 'gray',
    }}
    alignment={header.ident === 'ROWHEADER' ? 'right' : undefined}
    // fontSize=".8em"
    // fontWeight="bold"
    width={width}
    height={height}
  >
    {data[rowIndex][header.ident]}
  </FlexCell>
)

const cellRenderer = ({
  CLIENT,
  isAdminType,
  year,
  month,
  utility,
  unit,
  // setHourlyGenerationDOM,
  setGenerationDialogEvent,
  generationDialogEvent,
  domGenerationPermission = false,
  // apitargetInfo,
  // utilityNameMap,
  // unitNameMap,
}) => props => {
  const { rowIndex, width, height, data, header, columnIndex, ...rest } = props

  if (
    domGenerationPermission &&
    CLIENT === DOM_CLIENT &&
    (data[rowIndex].ROWHEADER === 'Gross MWH' ||
      data[rowIndex].ROWHEADER === 'Net MWH' ||
      data[rowIndex].ROWHEADER === 'SS MWH')
  ) {
    return (
      <Dropdown
        overlay={
          <Menu>
            <Menu.Item
              key="1"
              onClick={_ => {
                setGenerationDialogEvent({
                  isAdminType,
                  unitId: unit,
                  utility: utility,
                  unit: unit.substr(utility.length),
                  transdate: month + '/' + columnIndex + '/' + year,
                  setInsertEvent: setGenerationDialogEvent,
                  insertEvent: !!generationDialogEvent,
                  data: {
                    unitId: unit,
                    utility: utility,
                    unit: unit.substr(utility.length),
                    transdate: year + '-' + month + '-' + (columnIndex + 1),
                  },
                })
              }}
            >
              View Generation
            </Menu.Item>
            {/* <Menu.Item key="2">2nd menu item</Menu.Item> */}
          </Menu>
        }
        trigger={['contextMenu']}
      >
        {(data[rowIndex] || {}).STATUS === 'R' ? (
          <RestReadCell
            rest={rest}
            data={data}
            rowIndex={rowIndex}
            header={header}
            width={width}
            height={height}
            {...props}
          />
        ) : (
          defaultFlexCellRenderer(props)
        )}
        {/* {defaultFlexCellRenderer(props)} */}
        {/* <RestReadCell
          rest={rest}
          data={data}
          rowIndex={rowIndex}
          header={header}
          width={width}
          height={height}
          {...props}
        /> */}
      </Dropdown>
    )
  }

  if ((data[rowIndex] || {}).STATUS === 'R') {
    return (
      <RestReadCell
        rest={rest}
        data={data}
        rowIndex={rowIndex}
        header={header}
        width={width}
        height={height}
      />
    )
  }

  return defaultFlexCellRenderer(props)
}
const renderFlex = (screenSize, data) =>
  flexGridRenderer({
    headerRowHeight: 0,
    headerRowWidth: 0,
    // width: screenSize.width - 50,
    width: screenSize.hrColumnWidth,
    // height: 220,
    autoFixColByKey: true,
    // fixedColCount: 1,
    // fixedScrollHeightAdjustment: 1,
    colHeaderRenderer: defaultColHeaderRenderer,
    rowHeight: 18,
    cellRenderer: cellRenderer(data),
  })

export const daysCount = date =>
  parseInt(
    moment(date)
      .endOf('month')
      .format('D')
  )

const MonthlyDataTable = React.forwardRef(
  // eslint-disable-next-line no-unused-vars
  ({ date, data, screenSize, CLIENT, isAdminType, ...props }, ref) => {
    const [generationDialogEvent, setGenerationDialogEvent] = useState(false)

    const domGenerationPermission = useMemo(
      _ =>
        hasAccesPermits({
          authGodMode: props.envConfig.authGodMode,
          actionPermits: props.actionPermits,
          eventActions: [
            ScreenPermissions.ADMIN_GENERATION_BY_HOUR_DOM,
            ScreenPermissions.VIEW_GENERATION_BY_HOUR_DOM,
          ],
          matchAny: true,
        }),
      [props.actionPermits, props.envConfig.authGodMode]
    )

    if (data.length === 0) return ''

    const dayCount = daysCount(date)

    const headers = dayCount => {
      const hr = []

      R.range(1, dayCount + 1).forEach(d =>
        hr.push(
          strCol({
            ident: 'CONTENT' + d,
            display: d + '',
            width: props.hrColumnWidth,
            fontSize: '0.80em',
          })
        )
      )

      return hr
    }
    // return <div>hhh</div>

    // eslint-disable-next-line no-unused-vars
    const isEditable = ({ header, rowData }) => {
      return rowData.STATUS === 'W'
      // return true
    }

    const getTotal = dataObj => {
      const fin = R.range(1, 32)
        .map(i => dataObj['CONTENT' + i] || 0)
        .reduce((a, b) => parseFloat(a) + parseFloat(b))

      return numeral(numeral(fin).format('0.0000')).value()
    }

    const getContentValue = dataObj => {
      let valueObj = R.range(1, 32)
        .filter(i => !!dataObj['CONTENT' + i])
        .map(i => [
          'CONTENT' + i,
          numeral(
            numeral(dataObj['CONTENT' + i] || '').format('0.0000')
          ).value(),
        ])
      valueObj = R.fromPairs(valueObj)

      return valueObj
    }

    const mapEditRow = data => ({ ...data, ...getContentValue(data) })

    const editRow = editInfo => {
      const { setEditInfo, setData } = props

      const modData = data.map(d => {
        const latestDataObj = editInfo.updatedMap.get(d)
        if (latestDataObj) {
          return {
            ...latestDataObj,
            // modificationInfo: { user: null, modDate: moment() },
            // modificationInfo: undefined,
            TOTAL: getTotal(latestDataObj),
            updated: true,
          }
        } else {
          return d
        }
      })

      let editData = editInfo.updated
      editData = editData.map(d => ({
        ...d,
        // modificationInfo: { user: null, modDate: moment() },
        TOTAL: getTotal(d),
        // modificationInfo: undefined,
      }))
      setData(modData)
      setEditInfo({ ...editInfo, updated: editData })
      // this.setState({
      //   data: modData,
      //   editInfo: { ...editInfo, updated: editData },
      // })
    }

    return (
      <div>
        {generationDialogEvent && (
          <HourlyGenerationDetailsDOM
            {...generationDialogEvent}
            insertEvent={!!generationDialogEvent}
            onMainRetrieveData={props.retrieveData}
            isAdminType={isAdminType}
          />
        )}
        <Grid
          data={data}
          headers={headers(dayCount)}
          render={renderFlex(screenSize, {
            CLIENT,
            month: date.format('MM'),
            year: date.format('YYYY'),
            utility: props.utility,
            unit: props.unit,
            isAdminType,
            generationDialogEvent,
            setGenerationDialogEvent,
            domGenerationPermission,
          })}
          width={props.hrColumnWidth}
          isEditable={isEditable}
          editMode="cell"
          // onEditInfoChange={editInfo =>
          //   editRow(editInfo)(data, setEditInfo, setData)
          // }
          // onEditInfoChange={props.setEditInfo}
          onEditInfoChange={editRow}
          editInfo={props.editInfo}
          mapEditRow={mapEditRow}
        />
      </div>
    )
  }
)

const mapStateToProps = state => ({
  CLIENT: getClientInfo(state),
  isAdminType: isAdminType(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(MonthlyDataTable)
// export default MonthlyDataTable
